// @ts-strict-ignore
import { web } from "@hubble/tokens";
import { Flex } from "@hubble/web";
import styled from "styled-components";

export const FloatingQRCodeContainer = styled(Flex)`
  position: fixed;
  bottom: 1.25rem;
  right: 1.25rem;
  gap: 1.25rem;
  background: ${web.color.base.white};
  padding: 10px;
  z-index: 5;
  cursor: pointer;
  border-radius: 4px;
  max-width: 180px;
  box-sizing: border-box;
`;
